export default "__VITE_ASSET__Ct7YGacw__"